module.exports = {
  language: "English",
  global: {
    copyright: 'Powered by',
    dialog: {
      title: 'Tips',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    notify: {
      require: 'This item is required',
      imgsize: 'File size cannot exceed 15MB',
      imgtype: 'Only supports uploading pictures in .jpg, .jpeg, and .png formats',
      uploaded: 'File upload successfully',
      protocolpre: 'Please confirm that you have read',
      protocolsuffix: 'and other contents'
    },
    payment: {
      wxpay: 'WeChat Pay',
      alipay: 'Alipay',
      unionpay: 'UnionPay',
      paypal: 'Paypal',
      offline: 'Transfer payment',
    },
    picker: {
      confirm: 'Confirm',
      cancel: 'Cancel'
    }
  },
  ticket: {
    load: {
      loading: 'loading...',
      finished: 'No more',
      error: 'Request failed, click reload',
    },
    ticket: {
      detail: 'Detail',
      surplus: 'Surplus'
    },
    status: {
      nostart: 'The sale has not yet started',
      end: 'Sale has ended',
      empty: 'Sold out',
      notenough: 'Insufficient votes'
    },
    count: {
      text: 'From the beginning of the sale',
      format: 'DD days HH hours mm minutes ss seconds'
    },
    empty: {
      intro: 'No introduction'
    },
    unpaid: {
      title: 'Tips',
      msg: 'You have unpaid order',
      cancel: 'Cancel',
      confirm: 'Pay'
    }
  },
  footerbtn: {
    btntext: {
      next: 'Next step',
      submit: 'Submit',
      submiting: 'submit...'
    },
    coupon: {
      text: 'Coupon',
      placeholder: 'Please enter the coupon code',
      btntext: 'Submit'
    },
    detailtitle: 'Selected details',
    total: 'Total',
    empty: 'No records'
  },
  form: {
    title: 'Fill in the information',
    countrycode: 'Country code',
    verify: {
      label: 'Code',
      placeholder: 'Please enter verification code',
      empty: 'Please fill in the verification code',
      err: 'Incorrect verification code format',
      send: 'Send',
      format: 'ss s',
      emptyc: 'Please fill in the country code',
      emptyp: 'Please fill in cell phone number',
      success: 'Sending successfully, please pay attention to check the SMS',

    },
    businesscard: {
      discern: 'Content recognition...',
    },
    validator: {
      phone: 'The phone number format is wrong',
      email: 'Please enter a valid email address',
      idnumber: 'Please enter a valid ID number',
      digit: 'Please enter a whole number or a decimal; when a decimal is used, a maximum of two digits are kept after the decimal point',
      letter: 'Please do not enter characters other than letters',
      require: 'This item is required'
    },
    notify: {
      undone: 'Please fill in the '
    }
  },
  result: {
    title: 'Order information',
    info: {
      ordernum: 'Order ID',
      goods: 'Commodity',
      amount: 'Amount',
      payment: 'Payment',
      time: 'Time',
    },
    btn: {
      pay: 'Go to pay',
      buy: 'Continue to buy'
    },
    status: {
      wait: 'Wait for payment',
      success: 'Payment successful',
      invalid: 'Expired',
      cancel: 'Cancelled',
    },
    invoice: 'Request an invoice'
  },
  payment: {
    vouchertext: 'Click to upload payment voucher',
    submit: 'Submit',
    vouchertip: 'Please upload payment voucher',
    pagetip: 'Please open this page in WeChat'
  }
}